import React, { useState } from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Skeleton } from '../../components/Skeleton';
import { Button } from '../../components/ui/Button';
import { Card, SectionTitle } from '../../components/ui/Card';
import { useLocale } from '../../contexts/LocaleContext';
type Stage = 'idle' | 'preparing' | 'ready';
export function ExportData() {
  const {
    t
  } = useLocale();
  const [stage, setStage] = useState<Stage>('idle');
  const request = () => {
    setStage('preparing');
    window.setTimeout(() => setStage('ready'), 1600);
  };
  return <div className="px-2 pb-2" data-id="element-3384" data-mp="3d30l180j0113">
      <PageHeader title={t('account.export')} subtitle={t('export.subtitle')} showBack data-id="element-3385" data-mp="3czustjwloj15" />

      <Card className="p-2" data-id="element-3386" data-mp="3858scbs24avu">
        <SectionTitle data-id="element-3387" data-mp="sbqav35oos9h">{t('export.included')}</SectionTitle>
        <ul className="space-y-1" data-id="element-3388" data-mp="sa5fxcfgj7b3">
          {['export.item1', 'export.item2', 'export.item3', 'export.item4'].map(key => <li key={key} className="flex items-start gap-2 text-[12.5px] leading-snug text-deep" data-id="element-3389" data-mp="3nuq3vpulk6pi">
                <span className="mt-[6px] h-[5px] w-[5px] shrink-0 rounded-pill bg-gold" aria-hidden="true" data-id="element-3390" data-mp="3rtywushtc0k0" />
                {t(key)}
              </li>)}
        </ul>
      </Card>

      {stage === 'preparing' && <Card className="mt-2 p-2" data-id="element-3391" data-mp="347sg9hubpci6">
          <p className="text-[12.5px] font-medium text-deep" data-id="element-3392" data-mp="344d1yh8h47ht">
            {t('export.preparing')}
          </p>
          <Skeleton className="mt-2 h-[10px] w-full" data-id="element-3393" data-mp="3e4nd7way74uc" />
          <Skeleton className="mt-1 h-[10px] w-2/3" data-id="element-3394" data-mp="3e2stumfbrksd" />
        </Card>}

      {stage === 'ready' && <Card className="mt-2 border-gold/45 p-2" data-id="element-3395" data-mp="3iweuthc4m08c">
          <p className="flex items-center gap-1 text-[13px] font-medium text-gold-deep" data-id="element-3396" data-mp="2lg7xt8nwmkih">
            <CheckIcon size={14} strokeWidth={3} aria-hidden="true" data-id="element-3397" data-mp="2qe9itz4w4twl" />
            {t('export.ready')}
          </p>
          <p className="mt-1 text-[12px] leading-snug text-muted" data-id="element-3398" data-mp="2idblrxog8wpi">
            {t('export.readyBody')}
          </p>
        </Card>}

      <Button variant="gold" size="lg" fullWidth className="mt-3" disabled={stage === 'preparing'} onClick={request} data-id="element-3399" data-mp="2ec9nbj2cwool">
        <DownloadIcon size={17} data-id="element-3400" data-mp="2n64qwmnty724" />
        {stage === 'ready' ? t('export.again') : t('export.request')}
      </Button>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3401" data-mp="1zfivpvyxch9j">
        {t('export.note')}
      </p>
    </div>;
}